import { useState, useEffect, useRef, useCallback } from 'react';

const useSpeechRecognition = ({ lang = 'zh-CN', onResult }) => {
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const finalTranscriptRef = useRef('');
  const lastInterimRef = useRef('');

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.warn('浏览器不支持 Web Speech API');
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = lang;

    recognition.onresult = (event) => {
      let interimTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscriptRef.current += transcript;
        } else {
          interimTranscript += transcript;
        }
      }
      lastInterimRef.current = interimTranscript;
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event.error);
      stopListening();
    };

    recognitionRef.current = recognition;
    // cleanup
    return () => {
      recognition && recognition.stop();
    };
  }, [lang]);

  const stopListening = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);

      // ✅ 兼容特殊情况 —— 如果没触发 isFinal，则拼接最新 interim 部分
      let finalText = (finalTranscriptRef.current + lastInterimRef.current).trim();
      if (onResult) onResult(finalText);
    }
  }, [onResult]);

  const startListening = () => {
    if (recognitionRef.current) {
      finalTranscriptRef.current = '';
      lastInterimRef.current = '';
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  return {
    isListening,
    startListening,
    stopListening,
  };
};

export default useSpeechRecognition;